import * as i0 from '@angular/core';
import { Pipe, Component, ViewChild, EventEmitter, Input, Output, ViewEncapsulation, Directive, HostListener, NgModule } from '@angular/core';
import * as i1$1 from '@angular/forms';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as i2 from '@angular/common';
import { registerLocaleData, CommonModule, DecimalPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import * as i2$2 from '@am/moebius';
import { MbFormFieldModule, MbIconModule, MbTooltipModule } from '@am/moebius';
import { aciAdd, aciSub } from '@am/common-svg-icons';
import es from '@angular/common/locales/es';
import * as i2$1 from '@angular-slider/ngx-slider';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import * as i1 from '@ngrx/store';
import { map, filter } from 'rxjs/operators';
import * as i1$2 from '@am/alliance-service';
import { selectAlliancesAllyState, selectAlliancesRewardSessionState, selectAlliancesContextState, GetStateAction, RewardSession, Slider, ProductsSession, Source, CreditsRewards, CONVERSION_TYPES, AlliancesError, AlliancesServicesModule } from '@am/alliance-service';
import { throwError } from 'rxjs';

class ReplacePointsPipe {
    transform(text, points) {
        if (!text || !points) {
            return text;
        }
        return text.replace('${points}', points);
    }
}
ReplacePointsPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ReplacePointsPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ReplacePointsPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: ReplacePointsPipe, name: "replacePoints" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: ReplacePointsPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'replacePoints'
                }]
        }] });

class SliderInfoComponent {
    constructor(store) {
        this.store = store;
        /**
         * Store all component subscriptions that will be removed on destroy
         */
        this.subscriptions = [];
        registerLocaleData(es);
        this.brandConfig$ = this.store
            .select(selectAlliancesAllyState)
            .pipe(map((config) => {
            const { logo = '', color = '', slider = {} } = config;
            const { label: logoLabel = '' } = slider;
            return {
                logo,
                color,
                logoLabel
            };
        }));
        this.rewardSession$ = this.store
            .select(selectAlliancesRewardSessionState)
            .pipe(map((sessionData) => {
            const { reward } = sessionData;
            return (reward ? reward : { value: 0 });
        }));
    }
    ngAfterViewInit() {
        const sub = this.brandConfig$.subscribe(config => {
            const userPointsSpan = this.label.nativeElement
                .lastElementChild;
            userPointsSpan.style.color = config.color;
        });
        this.subscriptions.push(sub);
    }
    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
SliderInfoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SliderInfoComponent, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Component });
SliderInfoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SliderInfoComponent, selector: "am-slider-info", viewQueries: [{ propertyName: "label", first: true, predicate: ["logoLabel"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"slider-info__logo-box\">\n  <img class=\"slider-info__logo\" [src]=\"(brandConfig$ | async)?.logo\" />\n  <div\n    #logoLabel\n    class=\"slider-info__label\"\n    [innerHTML]=\"\n      (brandConfig$ | async)?.logoLabel\n        | replacePoints: ((rewardSession$ | async)?.value | number: '':'es')\n    \"\n  ></div>\n</div>\n", styles: [".am-payment-reward{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.am-payment-reward{line-height:1.5}}.slider-info{align-items:center;display:flex;flex-direction:column;text-align:left}.slider-info__logo{height:20px;margin:0 10px 0 0;min-width:20px;width:20px}.slider-info__logo-box{display:flex}@media screen and (max-width: 480px){.slider-info__logo{font-size:12px;height:18px;min-width:18px;width:18px}}.slider-info-label{font-size:.875rem;font-weight:var(--font-weight-semibold);line-height:1.5;color:#000!important}@media only screen and (max-width: 767px){.slider-info-label{line-height:1.5}}@media screen and (max-width: 480px){.slider-info-label{font-size:13px}}.slider-info__not-enough{padding-left:30px;font-weight:400}\n"], dependencies: [{ kind: "pipe", type: i2.AsyncPipe, name: "async" }, { kind: "pipe", type: i2.DecimalPipe, name: "number" }, { kind: "pipe", type: ReplacePointsPipe, name: "replacePoints" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SliderInfoComponent, decorators: [{
            type: Component,
            args: [{ selector: 'am-slider-info', template: "<div class=\"slider-info__logo-box\">\n  <img class=\"slider-info__logo\" [src]=\"(brandConfig$ | async)?.logo\" />\n  <div\n    #logoLabel\n    class=\"slider-info__label\"\n    [innerHTML]=\"\n      (brandConfig$ | async)?.logoLabel\n        | replacePoints: ((rewardSession$ | async)?.value | number: '':'es')\n    \"\n  ></div>\n</div>\n", styles: [".am-payment-reward{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.am-payment-reward{line-height:1.5}}.slider-info{align-items:center;display:flex;flex-direction:column;text-align:left}.slider-info__logo{height:20px;margin:0 10px 0 0;min-width:20px;width:20px}.slider-info__logo-box{display:flex}@media screen and (max-width: 480px){.slider-info__logo{font-size:12px;height:18px;min-width:18px;width:18px}}.slider-info-label{font-size:.875rem;font-weight:var(--font-weight-semibold);line-height:1.5;color:#000!important}@media only screen and (max-width: 767px){.slider-info-label{line-height:1.5}}@media screen and (max-width: 480px){.slider-info-label{font-size:13px}}.slider-info__not-enough{padding-left:30px;font-weight:400}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; }, propDecorators: { label: [{
                type: ViewChild,
                args: ['logoLabel', { static: true }]
            }] } });

class SliderGapComponent {
    constructor(store) {
        this.store = store;
        this.isVisible = true;
        this.valueLabel = '';
        this.isZeroGap = true;
        this.isSelected = false;
        this.showSelector = true;
        this.selectorLabel = '';
        this.isSelectedChange = new EventEmitter();
        this.brandConfig$ = this.store
            .select(selectAlliancesAllyState)
            .pipe(map((config) => {
            const { color = '#f00d08' } = config;
            return { color };
        }));
    }
    ngAfterViewInit() {
        const sub = this.brandConfig$.subscribe(config => {
            const { color } = config;
            if (!this.gapPointer) {
                return false;
            }
            const pointer = this.gapPointer.nativeElement;
            pointer.style.border = `1px solid ${color}`;
        });
    }
    onGapSelectChange() {
        this.isSelectedChange.emit(!this.isSelected);
    }
}
SliderGapComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SliderGapComponent, deps: [{ token: i1.Store }], target: i0.ɵɵFactoryTarget.Component });
SliderGapComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SliderGapComponent, selector: "am-slider-gap", inputs: { isVisible: "isVisible", valueLabel: "valueLabel", isZeroGap: "isZeroGap", isSelected: "isSelected", showSelector: "showSelector", selectorLabel: "selectorLabel" }, outputs: { isSelectedChange: "isSelectedChange" }, viewQueries: [{ propertyName: "gapPointer", first: true, predicate: ["gapPointer"], descendants: true }], ngImport: i0, template: "<div class=\"gap__content\" *ngIf=\"isVisible\">\n  <hr\n    class=\"gap__line\"\n    [ngClass]=\"{\n      'gap__line--zero': isZeroGap,\n      'gap__line--top': !isZeroGap\n    }\"\n  />\n\n  <div\n    class=\"gap__circle-box\"\n    [ngClass]=\"{\n      'gap__circle-box--zero': isZeroGap,\n      'gap__circle-box--top': !isZeroGap\n    }\"\n    [hidden]=\"!isSelected\"\n  >\n    <p class=\"gap__circle-label\">\n      {{ valueLabel }}\n    </p>\n\n    <div\n      #gapPointer\n      *ngIf=\"!isZeroGap\"\n      class=\"gap__circle\"\n      (click)=\"onGapSelectChange()\"\n      (swipeleft)=\"onGapSelectChange()\"\n    ></div>\n\n    <div\n      #gapPointer\n      *ngIf=\"isZeroGap\"\n      class=\"gap__circle\"\n      (click)=\"onGapSelectChange()\"\n      (swiperight)=\"onGapSelectChange()\"\n    ></div>\n  </div>\n\n  <div\n    *ngIf=\"!isSelected && showSelector\"\n    class=\"gap__selector\"\n    (click)=\"onGapSelectChange()\"\n    [ngClass]=\"{\n      'gap__selector--zero': isZeroGap,\n      'gap__selector--top': !isZeroGap\n    }\"\n  ></div>\n  <div\n    *ngIf=\"!isSelected\"\n    class=\"gap__selector-label\"\n    [ngClass]=\"{\n      'gap__selector-label--zero': isZeroGap,\n      'gap__selector-label--top': !isZeroGap\n    }\"\n  >\n    {{ selectorLabel }}\n  </div>\n</div>\n", styles: [".am-payment-reward{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.am-payment-reward{line-height:1.5}}.gap__content{align-items:center;display:flex;height:50px;min-width:124px;position:relative}.gap__content:hover>.gap__selector{opacity:1}@media screen and (max-width: 480px){.gap__content{min-width:40px!important}}.gap__line{background-image:linear-gradient(to right,#9fa2a2 70%,rgba(255,255,255,0) 0);background-position:inherit;background-repeat:repeat-x;background-size:14px 4px;border:0;height:4px;overflow:unset;position:relative;width:100%}.gap__line:before{background-color:#9fa2a2;content:\"\";height:20px;position:absolute;top:-7px;width:3px;z-index:3}.gap__line--top:before{left:-3px}.gap__line--zero:before{right:-3px}.gap__circle{background-color:#fff;border-radius:50%;cursor:pointer;display:inline-block;height:24px;width:24px}.gap__circle-box{position:absolute;top:50%;transform:translateY(calc(-50% + 1px))}.gap__circle-box--zero{left:0}.gap__circle-box--top{right:0}.gap__circle-label{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5;font-weight:600;letter-spacing:normal;line-height:1;margin-top:4px;position:absolute;right:0;text-align:right;top:-24px;width:100px}@media only screen and (max-width: 767px){.gap__circle-label{line-height:1.5}}.gap__selector{background-color:#fff;border:solid 1px rgba(119,119,119,.5411764706);border-radius:50%;cursor:pointer;display:inline-block;height:24px;opacity:0;position:absolute;top:50%;transform:translateY(calc(-50% - 1px));transition:opacity .2s ease-in-out,box-shadow .2s ease-in-out;width:24px}.gap__selector--zero{left:0}.gap__selector--top{right:0}.gap__selector:hover{box-shadow:2px 2px 4px #cfcfcf}.gap__selector:hover~.gap__selector-label{opacity:1}.gap__selector-label{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5;background-color:#fff;opacity:0;padding:5px;position:absolute;top:45px;transition:opacity .2s ease-in-out;width:130px;z-index:5}@media only screen and (max-width: 767px){.gap__selector-label{line-height:1.5}}.gap__selector-label--top{text-align:right}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SliderGapComponent, decorators: [{
            type: Component,
            args: [{ selector: 'am-slider-gap', template: "<div class=\"gap__content\" *ngIf=\"isVisible\">\n  <hr\n    class=\"gap__line\"\n    [ngClass]=\"{\n      'gap__line--zero': isZeroGap,\n      'gap__line--top': !isZeroGap\n    }\"\n  />\n\n  <div\n    class=\"gap__circle-box\"\n    [ngClass]=\"{\n      'gap__circle-box--zero': isZeroGap,\n      'gap__circle-box--top': !isZeroGap\n    }\"\n    [hidden]=\"!isSelected\"\n  >\n    <p class=\"gap__circle-label\">\n      {{ valueLabel }}\n    </p>\n\n    <div\n      #gapPointer\n      *ngIf=\"!isZeroGap\"\n      class=\"gap__circle\"\n      (click)=\"onGapSelectChange()\"\n      (swipeleft)=\"onGapSelectChange()\"\n    ></div>\n\n    <div\n      #gapPointer\n      *ngIf=\"isZeroGap\"\n      class=\"gap__circle\"\n      (click)=\"onGapSelectChange()\"\n      (swiperight)=\"onGapSelectChange()\"\n    ></div>\n  </div>\n\n  <div\n    *ngIf=\"!isSelected && showSelector\"\n    class=\"gap__selector\"\n    (click)=\"onGapSelectChange()\"\n    [ngClass]=\"{\n      'gap__selector--zero': isZeroGap,\n      'gap__selector--top': !isZeroGap\n    }\"\n  ></div>\n  <div\n    *ngIf=\"!isSelected\"\n    class=\"gap__selector-label\"\n    [ngClass]=\"{\n      'gap__selector-label--zero': isZeroGap,\n      'gap__selector-label--top': !isZeroGap\n    }\"\n  >\n    {{ selectorLabel }}\n  </div>\n</div>\n", styles: [".am-payment-reward{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.am-payment-reward{line-height:1.5}}.gap__content{align-items:center;display:flex;height:50px;min-width:124px;position:relative}.gap__content:hover>.gap__selector{opacity:1}@media screen and (max-width: 480px){.gap__content{min-width:40px!important}}.gap__line{background-image:linear-gradient(to right,#9fa2a2 70%,rgba(255,255,255,0) 0);background-position:inherit;background-repeat:repeat-x;background-size:14px 4px;border:0;height:4px;overflow:unset;position:relative;width:100%}.gap__line:before{background-color:#9fa2a2;content:\"\";height:20px;position:absolute;top:-7px;width:3px;z-index:3}.gap__line--top:before{left:-3px}.gap__line--zero:before{right:-3px}.gap__circle{background-color:#fff;border-radius:50%;cursor:pointer;display:inline-block;height:24px;width:24px}.gap__circle-box{position:absolute;top:50%;transform:translateY(calc(-50% + 1px))}.gap__circle-box--zero{left:0}.gap__circle-box--top{right:0}.gap__circle-label{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5;font-weight:600;letter-spacing:normal;line-height:1;margin-top:4px;position:absolute;right:0;text-align:right;top:-24px;width:100px}@media only screen and (max-width: 767px){.gap__circle-label{line-height:1.5}}.gap__selector{background-color:#fff;border:solid 1px rgba(119,119,119,.5411764706);border-radius:50%;cursor:pointer;display:inline-block;height:24px;opacity:0;position:absolute;top:50%;transform:translateY(calc(-50% - 1px));transition:opacity .2s ease-in-out,box-shadow .2s ease-in-out;width:24px}.gap__selector--zero{left:0}.gap__selector--top{right:0}.gap__selector:hover{box-shadow:2px 2px 4px #cfcfcf}.gap__selector:hover~.gap__selector-label{opacity:1}.gap__selector-label{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5;background-color:#fff;opacity:0;padding:5px;position:absolute;top:45px;transition:opacity .2s ease-in-out;width:130px;z-index:5}@media only screen and (max-width: 767px){.gap__selector-label{line-height:1.5}}.gap__selector-label--top{text-align:right}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.Store }]; }, propDecorators: { gapPointer: [{
                type: ViewChild,
                args: ['gapPointer', { static: false }]
            }], isVisible: [{
                type: Input
            }], valueLabel: [{
                type: Input
            }], isZeroGap: [{
                type: Input
            }], isSelected: [{
                type: Input
            }], showSelector: [{
                type: Input
            }], selectorLabel: [{
                type: Input
            }], isSelectedChange: [{
                type: Output
            }] } });

// angular
class LineSliderComponent {
    /**
     * A setter for selectedPoints Input
     * Sets the slider values
     */
    set selectedPoints(propValue) {
        this.updateSlider(propValue || 0, true);
    }
    get selectedPoints() {
        return this._selectedValue;
    }
    /**
     * Used to store the selected value for the gap between 0 and this.minLimit
     */
    get isZeroGapSelected() {
        return this.selectedPoints === 0 && this.minLimit > 0;
    }
    /**
     * Used to store the selected value for the gap between this.maxLimit and this.top
     */
    get isTopGapSelected() {
        return this.selectedPoints === this.top && this.top > this.maxLimit;
    }
    /**
     * Used to know when any gap is selected and
     * remove the gn5-slider circle
     */
    get isAnyGapSelected() {
        return this.isZeroGapSelected || this.isTopGapSelected;
    }
    /**
     * Evaluates if it should show the zero gap
     */
    get showZeroGap() {
        return this.minLimit > 0;
    }
    /**
     * Evaluates if it should show the top gap
     */
    get showTopGap() {
        return this.top > this.maxLimit;
    }
    /**
     * Evaluates if the top gap can be selectable
     */
    get canReachTopGap() {
        return this.points >= this.top;
    }
    constructor(decimalPipe) {
        this.decimalPipe = decimalPipe;
        /**
         * Minimal non zero selectable value.
         * minLimit can also be zero (0)
         *
         *   [= = = = = = =|===========...
         *  Zero (0)    minLimit
         *
         *   [|===========...
         *  Zero (=)
         * minLimit
         */
        this.minLimit = 0;
        /**
         * User available points
         */
        this.points = 0;
        /**
         * Emit slider changes
         */
        this.selectedPointsChange = new EventEmitter();
        /**
         * Used for refresh slider view
         *
         * (See Manual refresh: https://angular-slider.github.io/ngx-slider/docs)
         */
        this.refresh = new EventEmitter();
        registerLocaleData(es);
    }
    ngOnInit() {
        this.options = this.getSliderOptions();
    }
    ngAfterViewInit() {
        const { color = '#f00d08' } = this.brandConfig;
        const selectionLine = this.sliderBox.nativeElement.querySelector('.ngx-slider-selection');
        const pointer = this.sliderBox.nativeElement.querySelector('.ngx-slider-pointer');
        selectionLine.style.backgroundColor = color;
        pointer.style.border = `solid 1px ${color}`;
    }
    /**
     * Updates the slider value and emit it.
     * This emit new value only if this functions is not called in a input setter
     * (emitting the value incoming from a setter could cause infinite update loop)
     *
     * @param value new slider value
     * @param input to know if is called from a input setter
     */
    updateSlider(value, input = false) {
        this._selectedValue = this.validatePoints(value);
        this.sliderValue = this._selectedValue;
        this.refresh.emit();
        if (input) {
            // we don't need to emit changes when input updates
            return;
        }
        this.emitValueChange();
    }
    validatePoints(value) {
        if (this.points < this.maxLimit && value > this.points) {
            return this.points;
        }
        if (value < this.minLimit && value !== 0) {
            return this.minLimit;
        }
        if (value > this.maxLimit && value !== this.top) {
            return this.maxLimit;
        }
        return value;
    }
    /**
     * Generates the slider options
     *
     * @returns Options instance
     */
    getSliderOptions() {
        const floor = this.minLimit;
        const ceil = this.maxLimit;
        const showSelectionBar = true;
        // To add a point in the slider to show the user points
        const ticksArray = this.points < this.maxLimit ? [this.points] : [];
        const stringPoints = (value) => this.toDecimalFormat(value);
        const ticksTooltip = (value) => `Tenés ${stringPoints(value)} pts`;
        const translate = (value) => `<b>${stringPoints(value)}</b> pts`;
        return {
            floor,
            ceil,
            showSelectionBar,
            ticksArray,
            ticksTooltip,
            translate
        };
    }
    /**
     * Transform a number value to locale 'es' decimal format
     *
     * @param value values to transform
     */
    toDecimalFormat(value) {
        return this.decimalPipe.transform(value, '', 'es');
    }
    /**
     * Emit current selected points
     *
     */
    emitValueChange() {
        this.selectedPointsChange.emit(this.selectedPoints);
    }
    /**
     *  [Event Handler]
     *
     *  listens the gaps change event and
     *  calculates the new value for the slider, depending on the gap is being selected or deselected, and call to update it
     *
     *  Value for those variables are mutually exclusive
     *
     * @param value new selected gap value
     * @param isZeroGap to know if the change if for zero gap or top gap
     */
    onGapSelectedChange(value, isZeroGap) {
        let newSliderValue;
        if (isZeroGap) {
            newSliderValue = value ? 0 : this.sliderValue;
        }
        else {
            newSliderValue =
                value && this.canReachTopGap ? this.top : this.sliderValue;
        }
        this.updateSlider(newSliderValue);
    }
    /**
     * [Event Handler]
     *
     * Listen the ngx-slider change end event and update the selectedPoints value
     * @param changeContext
     */
    onUserChangeEnd(changeContext) {
        const { value } = changeContext;
        this.updateSlider(value);
    }
}
LineSliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LineSliderComponent, deps: [{ token: i2.DecimalPipe }], target: i0.ɵɵFactoryTarget.Component });
LineSliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: LineSliderComponent, selector: "am-line-slider", inputs: { brandConfig: "brandConfig", minLimit: "minLimit", maxLimit: "maxLimit", top: "top", points: "points", selectedPoints: "selectedPoints" }, outputs: { selectedPointsChange: "selectedPointsChange" }, viewQueries: [{ propertyName: "sliderBox", first: true, predicate: ["sliderBox"], descendants: true }], ngImport: i0, template: "<div class=\"slider__content\">\n  <div class=\"slider__info\">\n    <am-slider-info></am-slider-info>\n  </div>\n\n  <div class=\"slider__box\" #sliderBox>\n    <am-slider-gap\n      [isVisible]=\"showZeroGap\"\n      [isSelected]=\"isZeroGapSelected\"\n      [valueLabel]=\"'0 pts'\"\n      [selectorLabel]=\"'Pagar todo con dinero'\"\n      (isSelectedChange)=\"onGapSelectedChange($event, true)\"\n    ></am-slider-gap>\n\n    <ngx-slider\n      [ngClass]=\"{\n        'slider__line--with-gap': isAnyGapSelected,\n        'slider__line--collapsed': isZeroGapSelected,\n        'slider__line--expanded': isTopGapSelected\n      }\"\n      [(value)]=\"sliderValue\"\n      [options]=\"options\"\n      [manualRefresh]=\"refresh\"\n      (userChangeEnd)=\"onUserChangeEnd($event)\"\n    >\n    </ngx-slider>\n\n    <am-slider-gap\n      [isZeroGap]=\"false\"\n      [isVisible]=\"showTopGap\"\n      [isSelected]=\"isTopGapSelected\"\n      [showSelector]=\"canReachTopGap\"\n      [valueLabel]=\"(this.top | number: '':'es') + ' pts'\"\n      [selectorLabel]=\"'Pagar todo con puntos'\"\n      (isSelectedChange)=\"onGapSelectedChange($event, false)\"\n    ></am-slider-gap>\n  </div>\n\n  <div class=\"slider__total-points\">\n    <b>{{ top | number: '':'es' }}</b>\n    <span> pts</span>\n    <br />\n    <span> totales</span>\n    <br />\n  </div>\n</div>\n", styles: [".am-payment-reward{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.am-payment-reward{line-height:1.5}}.slider__content{align-items:flex-start;display:flex;flex-direction:column;justify-content:center}.slider__content .ngx-slider{margin:20px 0}.slider__info{font-size:.875rem;font-weight:var(--font-weight-semibold);line-height:1.5;margin-bottom:30px;width:100%}@media only screen and (max-width: 767px){.slider__info{line-height:1.5}}.slider__box{align-items:center;display:flex;width:100%}.slider__total-points{font-size:.875rem;font-weight:var(--font-weight-semibold);line-height:1.5;letter-spacing:normal;line-height:1;margin-top:4px;position:relative;text-align:right;width:100%}@media only screen and (max-width: 767px){.slider__total-points{line-height:1.5}}.slider__total-points>span{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.slider__total-points>span{line-height:1.5}}.ngx-slider-bar{background:#dddede}.ngx-slider-selection{height:3px!important;transition:all linear .3s!important}.ngx-slider-pointer{background-color:#fff!important;display:inline-block;height:24px!important;top:-11px!important;width:24px!important;z-index:4!important}.ngx-slider-pointer:focus{outline:none!important}.ngx-slider-pointer.ngx-slider-active:after{opacity:0!important}.ngx-slider-bubble{padding:0 0 6px 6px!important}.ngx-slider-bubble.ngx-slider-span.ngx-slider-model-value{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5;color:var(--color-text-dark)}@media only screen and (max-width: 767px){.ngx-slider-bubble.ngx-slider-span.ngx-slider-model-value{line-height:1.5}}.ngx-slider-limit{display:none!important}.ngx-slider.slider__line--with-gap .ngx-slider-pointer,.ngx-slider.slider__line--with-gap .ngx-slider-model-value{opacity:0!important;visibility:hidden!important}.ngx-slider.slider__line--collapsed .ngx-slider-selection{visibility:hidden!important}.ngx-slider.slider__line--expanded .ngx-slider-bar,.ngx-slider.slider__line--expanded .ngx-slider-bar-wrapper{width:100%!important}\n"], dependencies: [{ kind: "directive", type: i2.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: i2$1.SliderComponent, selector: "ngx-slider", inputs: ["value", "highValue", "options", "manualRefresh", "triggerFocus"], outputs: ["valueChange", "highValueChange", "userChangeStart", "userChange", "userChangeEnd"] }, { kind: "component", type: SliderInfoComponent, selector: "am-slider-info" }, { kind: "component", type: SliderGapComponent, selector: "am-slider-gap", inputs: ["isVisible", "valueLabel", "isZeroGap", "isSelected", "showSelector", "selectorLabel"], outputs: ["isSelectedChange"] }, { kind: "pipe", type: i2.DecimalPipe, name: "number" }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: LineSliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'am-line-slider', encapsulation: ViewEncapsulation.None, template: "<div class=\"slider__content\">\n  <div class=\"slider__info\">\n    <am-slider-info></am-slider-info>\n  </div>\n\n  <div class=\"slider__box\" #sliderBox>\n    <am-slider-gap\n      [isVisible]=\"showZeroGap\"\n      [isSelected]=\"isZeroGapSelected\"\n      [valueLabel]=\"'0 pts'\"\n      [selectorLabel]=\"'Pagar todo con dinero'\"\n      (isSelectedChange)=\"onGapSelectedChange($event, true)\"\n    ></am-slider-gap>\n\n    <ngx-slider\n      [ngClass]=\"{\n        'slider__line--with-gap': isAnyGapSelected,\n        'slider__line--collapsed': isZeroGapSelected,\n        'slider__line--expanded': isTopGapSelected\n      }\"\n      [(value)]=\"sliderValue\"\n      [options]=\"options\"\n      [manualRefresh]=\"refresh\"\n      (userChangeEnd)=\"onUserChangeEnd($event)\"\n    >\n    </ngx-slider>\n\n    <am-slider-gap\n      [isZeroGap]=\"false\"\n      [isVisible]=\"showTopGap\"\n      [isSelected]=\"isTopGapSelected\"\n      [showSelector]=\"canReachTopGap\"\n      [valueLabel]=\"(this.top | number: '':'es') + ' pts'\"\n      [selectorLabel]=\"'Pagar todo con puntos'\"\n      (isSelectedChange)=\"onGapSelectedChange($event, false)\"\n    ></am-slider-gap>\n  </div>\n\n  <div class=\"slider__total-points\">\n    <b>{{ top | number: '':'es' }}</b>\n    <span> pts</span>\n    <br />\n    <span> totales</span>\n    <br />\n  </div>\n</div>\n", styles: [".am-payment-reward{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.am-payment-reward{line-height:1.5}}.slider__content{align-items:flex-start;display:flex;flex-direction:column;justify-content:center}.slider__content .ngx-slider{margin:20px 0}.slider__info{font-size:.875rem;font-weight:var(--font-weight-semibold);line-height:1.5;margin-bottom:30px;width:100%}@media only screen and (max-width: 767px){.slider__info{line-height:1.5}}.slider__box{align-items:center;display:flex;width:100%}.slider__total-points{font-size:.875rem;font-weight:var(--font-weight-semibold);line-height:1.5;letter-spacing:normal;line-height:1;margin-top:4px;position:relative;text-align:right;width:100%}@media only screen and (max-width: 767px){.slider__total-points{line-height:1.5}}.slider__total-points>span{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.slider__total-points>span{line-height:1.5}}.ngx-slider-bar{background:#dddede}.ngx-slider-selection{height:3px!important;transition:all linear .3s!important}.ngx-slider-pointer{background-color:#fff!important;display:inline-block;height:24px!important;top:-11px!important;width:24px!important;z-index:4!important}.ngx-slider-pointer:focus{outline:none!important}.ngx-slider-pointer.ngx-slider-active:after{opacity:0!important}.ngx-slider-bubble{padding:0 0 6px 6px!important}.ngx-slider-bubble.ngx-slider-span.ngx-slider-model-value{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5;color:var(--color-text-dark)}@media only screen and (max-width: 767px){.ngx-slider-bubble.ngx-slider-span.ngx-slider-model-value{line-height:1.5}}.ngx-slider-limit{display:none!important}.ngx-slider.slider__line--with-gap .ngx-slider-pointer,.ngx-slider.slider__line--with-gap .ngx-slider-model-value{opacity:0!important;visibility:hidden!important}.ngx-slider.slider__line--collapsed .ngx-slider-selection{visibility:hidden!important}.ngx-slider.slider__line--expanded .ngx-slider-bar,.ngx-slider.slider__line--expanded .ngx-slider-bar-wrapper{width:100%!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i2.DecimalPipe }]; }, propDecorators: { sliderBox: [{
                type: ViewChild,
                args: ['sliderBox', { static: false }]
            }], brandConfig: [{
                type: Input
            }], minLimit: [{
                type: Input
            }], maxLimit: [{
                type: Input
            }], top: [{
                type: Input
            }], points: [{
                type: Input
            }], selectedPoints: [{
                type: Input
            }], selectedPointsChange: [{
                type: Output
            }] } });

const SLIDER_VISIBILITY_CONFIG = {
    ARG: {
        brands: ['superclub']
    }
};

// angular
class AmInputSliderComponent {
    /**
     * A setter for selectedPoints Input
     * Sets the value for _selectedValue
     */
    set selectedPoints(propValue) {
        this.updateInputValue(propValue || 0, true);
    }
    get selectedPoints() {
        return this._selectedValue;
    }
    constructor() {
        /**
         * Minimal non zero input value.
         * minLimit can also be zero (0)
         */
        this.minLimit = 0;
        /**
         * User available points
         */
        this.points = 0;
        /**
         * Emit slider changes
         */
        this.selectedPointsChange = new EventEmitter();
        /**
         * To store plain input value
         */
        this._selectedValue = 0;
        /**
         * Stores formatted input value
         */
        this.inputValue = '';
        registerLocaleData(es);
    }
    ngAfterViewInit() {
        const elements = [
            this.suffix.nativeElement,
            this.input.nativeElement
        ];
        const { color } = this.brandConfig;
        elements.forEach(e => (e.style.color = color));
    }
    /**
     * [Event handler]
     * calls to update the input values
     *
     * @param e input event
     */
    onChangePoints(e) {
        const { target } = e;
        const { value } = target;
        this.updateInputValue(value);
    }
    /**
     * Validates and update plain value
     * Formats the new inputValue value and set it
     *
     * if the update does not come from a input,
     * this method call to emit the new value
     *
     * @param value new value to update
     * @param isInput to know if the update comes from a input setter
     */
    updateInputValue(value, isInput = false) {
        this._selectedValue = this.validatePoints(value.toString());
        this.inputValue = this.formatNumber(this._selectedValue.toString());
        if (isInput) {
            return;
        }
        this.emitSelectedPoints();
    }
    /**
     * Adds numeric divisors.
     *
     * 1000 => 1.000
     * 200 => 200
     *
     * @param num value to format
     */
    formatNumber(num) {
        const cleanNumber = num.replace(/\D/g, '');
        const numb = parseInt(cleanNumber, 10);
        return numb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    /**
     * Emit new value of this.selectedPoints
     */
    emitSelectedPoints() {
        this.selectedPointsChange.emit(this.selectedPoints);
    }
    /**
     * Validates the number scope, the value can be equal:
     * - 0
     * - from this.minLimit to this.maxLimit
     * - this.top
     *
     * If the user hasn't points enough to reach the given value,
     * and this.points is less than this.maxLimit, the return will be this.points
     *
     * @param value value to evaluate
     */
    validatePoints(value) {
        const plainStringNumber = value.replace(/\D/g, '');
        const valueNumber = +plainStringNumber;
        if (this.points < this.maxLimit && valueNumber > this.points) {
            return this.points;
        }
        if (valueNumber < this.minLimit && valueNumber !== 0) {
            return this.minLimit;
        }
        if (valueNumber > this.maxLimit && valueNumber !== this.top) {
            return this.maxLimit;
        }
        return valueNumber;
    }
}
AmInputSliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmInputSliderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AmInputSliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AmInputSliderComponent, selector: "am-input-slider", inputs: { brandConfig: "brandConfig", minLimit: "minLimit", maxLimit: "maxLimit", top: "top", points: "points", selectedPoints: "selectedPoints" }, outputs: { selectedPointsChange: "selectedPointsChange" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true, static: true }, { propertyName: "suffix", first: true, predicate: ["suffix"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"slider-input__content\">\n  <div class=\"slider-input__field-box\">\n    <mb-form-field appearance=\"light\">\n      <label mb-form-field-label for=\"am-slider-points\">{{\n        brandConfig?.slider?.input\n      }}</label>\n      <input\n        #input\n        mb-form-field-input\n        class=\"slider-input__field\"\n        type=\"text\"\n        id=\"am-slider-points\"\n        [(ngModel)]=\"inputValue\"\n        (change)=\"onChangePoints($event)\"\n      />\n    </mb-form-field>\n    <span class=\"slider-input__suffix\" #suffix>pts</span>\n  </div>\n</div>\n", styles: [".am-payment-reward{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.am-payment-reward{line-height:1.5}}.slider-input__content{width:180px;margin-left:14px;display:flex;align-items:center;justify-content:center}.slider-input__field{box-sizing:border-box;color:red!important;padding-right:30px;text-align:right}.slider-input__field-box{width:120px;position:relative}.slider-input__suffix{color:red!important;position:absolute;top:26px;font-size:16px;right:11px}\n"], dependencies: [{ kind: "directive", type: i1$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i2$2.MbFormField, selector: "mb-form-field", inputs: ["appearance", "loading"] }, { kind: "directive", type: i2$2.MbFormFieldLabel, selector: "label[mb-form-field-label]" }, { kind: "directive", type: i2$2.MbFormFieldInput, selector: "input[mb-form-field-input],textarea[mb-form-field-input]", inputs: ["disabled"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmInputSliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'am-input-slider', template: "<div class=\"slider-input__content\">\n  <div class=\"slider-input__field-box\">\n    <mb-form-field appearance=\"light\">\n      <label mb-form-field-label for=\"am-slider-points\">{{\n        brandConfig?.slider?.input\n      }}</label>\n      <input\n        #input\n        mb-form-field-input\n        class=\"slider-input__field\"\n        type=\"text\"\n        id=\"am-slider-points\"\n        [(ngModel)]=\"inputValue\"\n        (change)=\"onChangePoints($event)\"\n      />\n    </mb-form-field>\n    <span class=\"slider-input__suffix\" #suffix>pts</span>\n  </div>\n</div>\n", styles: [".am-payment-reward{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.am-payment-reward{line-height:1.5}}.slider-input__content{width:180px;margin-left:14px;display:flex;align-items:center;justify-content:center}.slider-input__field{box-sizing:border-box;color:red!important;padding-right:30px;text-align:right}.slider-input__field-box{width:120px;position:relative}.slider-input__suffix{color:red!important;position:absolute;top:26px;font-size:16px;right:11px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { input: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }], suffix: [{
                type: ViewChild,
                args: ['suffix', { static: true }]
            }], brandConfig: [{
                type: Input
            }], minLimit: [{
                type: Input
            }], maxLimit: [{
                type: Input
            }], top: [{
                type: Input
            }], points: [{
                type: Input
            }], selectedPoints: [{
                type: Input
            }], selectedPointsChange: [{
                type: Output
            }] } });

// angular
/**
 * @description
 * @export SliderCompo
 * @class SliderComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
class SliderComponent {
    get isCheckoutSlider() {
        return !!this.cartProducts.length;
    }
    get isFlights() {
        return this.channelProduct.toLowerCase() === 'flight';
    }
    /**
     * To show or hide the tex about taxes,
     * this should only be displayed in the checkout slider
     * and if the top (amount with taxes in points)
     * is greater than the maxLimit (amount without taxes in point)
     */
    get showTaxesLabel() {
        if (!this.availabilityRewards) {
            return false;
        }
        const { cartPoints: top, pointsPaymentRange: { max: maxLimit } } = this.availabilityRewards;
        return this.isCheckoutSlider && top > maxLimit;
    }
    /**
     * Creates an instance of SliderComponent.
     * @param alliancesService
     * @param {Store<AppState>} store
     * @memberof SliderComponent
     */
    constructor(alliancesService, store) {
        this.alliancesService = alliancesService;
        this.store = store;
        /**
         * Forces component to despawn
         */
        // tslint:disable-next-line:no-input-rename
        this.isForceHiding = false;
        /**
         * Purchase products
         */
        // tslint:disable-next-line:no-input-rename
        this.cartProducts = [];
        /**
         * Current product (lights, hotels, etc...)
         */
        // tslint:disable-next-line:no-input-rename
        this.channelProduct = '';
        /**
         * Emits every slider change
         *
         *
         */
        // tslint:disable-next-line:no-input-rename no-output-on-prefix
        this.onSelectedPointsChange = new EventEmitter();
        this.outError = new EventEmitter();
        this.rewardSessionKey = 'rewardSession';
        this.subscriptions = [];
        this.brandConfig$ = this.store.select(selectAlliancesAllyState);
        this.context$ = this.store.select(selectAlliancesContextState);
        this.rewardSession$ = this.store.select(selectAlliancesRewardSessionState).pipe(filter(rs => !!rs));
    }
    /**
     * @description get store,set reward, set ally,
     * set context session and buildSlider
     * @memberof SliderComponent
     */
    ngOnInit() {
        const sessionDataSub = this.rewardSession$.subscribe((rewardSession) => {
            this.rewardSession = this.buildRewardSession(rewardSession);
            this.slider = this.rewardSession.slider;
            if (this.isCheckoutSlider) {
                this.loadPriceAndTaxes();
            }
            else {
                const { points } = this.slider;
                this.availabilityRewards = this.initAvailabilityRewards(points);
                this.initSelectedValue();
            }
        });
        this.subscriptions.push(sessionDataSub);
        this.store.dispatch(new GetStateAction());
    }
    /**
     * @description Removes all component subscriptions on destroy
     * @memberof SliderComponent
     */
    ngOnDestroy() {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }
    /**
     * Validates if the slider is available for the current context
     * Or if is forced to be hide
     *
     * @param context Almundo context
     */
    showComponent(context) {
        const { brand, country, country_code = 'arg' } = context;
        const countryCode = country || country_code;
        const countryConfig = SLIDER_VISIBILITY_CONFIG[countryCode.toUpperCase()];
        if (!countryConfig) {
            return false;
        }
        const { brands } = countryConfig;
        return !this.isForceHiding && brands.includes(brand.toLowerCase());
    }
    buildRewardSession(rSession) {
        const { reward, brand, name, site, timestamp, user_session_id } = rSession;
        const { value, conversion: { conversion_factor, conversion_rate_type } } = reward;
        const rewardSession = new RewardSession(reward)
            .builder()
            .brand(brand)
            .name(name)
            .site(site)
            .timestamp(timestamp)
            .user_session_id(user_session_id)
            .reward(reward)
            .slider(new Slider(reward)
            .builder()
            .points(value)
            .selectedPoints(value)
            .CONVERSION_FACTOR(conversion_factor)
            .CONVERSION_RATE_TYPE(conversion_rate_type)
            .build())
            .build();
        return rewardSession;
    }
    loadPriceAndTaxes() {
        const onPriceTaxesData = (aReward) => {
            this.availabilityRewards = aReward;
            this.initSelectedValue();
        };
        const handlePriceTaxesError = err => this.handleError(err);
        const priceAndTaxesSub = this.getPricesAndTaxes().subscribe(onPriceTaxesData, handlePriceTaxesError);
        this.subscriptions.push(priceAndTaxesSub);
    }
    getPricesAndTaxes() {
        const productsSession = this.buildPriceAndTaxesBody();
        return this.alliancesService.getPriceAndTaxes(productsSession);
    }
    /**
     * Build get and prices body.
     */
    buildPriceAndTaxesBody() {
        return new ProductsSession()
            .builder()
            .user_session_id(this.rewardSession.user_session_id)
            .products(this.cartProducts)
            .source(new Source()
            .builder()
            .brand(this.rewardSession.brand.toString().toUpperCase())
            .channel('WEB')
            .country(this.rewardSession.site)
            .build())
            .build();
    }
    /**
     * @description initialize slider
     * @memberof SliderComponent
     */
    initSelectedValue() {
        const { points: userPoints } = this.slider;
        const sSelectedPoints = this.getStorageSelectedPoints();
        let { selectedPoints } = this.slider;
        selectedPoints =
            sSelectedPoints && sSelectedPoints < userPoints
                ? sSelectedPoints
                : userPoints;
        if (this.isCheckoutSlider) {
            const { pointsPaymentRange: { max, min }, cartPoints } = this.availabilityRewards;
            if (selectedPoints < min && selectedPoints !== 0) {
                selectedPoints = min;
            }
            else if (selectedPoints > max && selectedPoints !== cartPoints) {
                selectedPoints = max;
            }
            else if (selectedPoints > cartPoints) {
                selectedPoints = cartPoints;
            }
        }
        this.slider = { ...this.slider, selectedPoints };
        // Emits the the initial selected points
        const initialSelected = this.isFlights ? 0 : this.slider.selectedPoints;
        this.onEmitterSelectedPoints(initialSelected);
    }
    getStorageSelectedPoints() {
        const storageRewardSession = this.readSessionStoreReward() || {};
        const { slider = {} } = storageRewardSession;
        const { selectedPoints } = slider;
        return selectedPoints;
    }
    /**
     * @description read session Store and return object Session Reward
     * @returns {RewardSession}
     * @memberof SliderComponent
     */
    readSessionStoreReward() {
        const rewardSession = window.sessionStorage.getItem(this.rewardSessionKey);
        try {
            return JSON.parse(rewardSession);
        }
        catch (err) { }
    }
    /**
     * @description Init the result page availability rewards
     * sets max an cartPoints to user available points
     * @returns {AvailabilityRewards}
     * @memberof SliderComponent
     */
    initAvailabilityRewards(maxPoints) {
        return {
            id: '',
            pointConversion: {
                conversionRateType: '',
                conversionFactor: 0
            },
            pointsPaymentRange: {
                min: 0,
                max: maxPoints
            },
            cartPoints: maxPoints
        };
    }
    onEmitterSelectedPoints(points) {
        this.rewardSession.slider.selectedPoints = points;
        this.slider = this.rewardSession.slider;
        this.creditsRewards = this.buildCreditRewards();
        this.setSessionStore();
        document.dispatchEvent(new CustomEvent('OnSelectedPointsRewards', {
            detail: this.rewardSession.slider
        }));
        this.validSendTypeRewards();
    }
    buildCreditRewards() {
        const points = this.rewardSession.slider.selectedPoints;
        // Validation required for checkout, rewardId must be null if selected points is equal to 0
        const rewardId = points > 0 ? this.availabilityRewards.id : null;
        return new CreditsRewards()
            .builder()
            .amount(this.calculateAmountMoneyRewards())
            .type(this.rewardSession.brand)
            .points(points)
            .rewardId(rewardId)
            .build();
    }
    calculateAmountMoneyRewards() {
        let convertPointToAmmount = 0;
        if (this.rewardSession.reward.conversion.conversion_rate_type ===
            CONVERSION_TYPES.CURRENCY_BY_CREDIT) {
            convertPointToAmmount =
                this.rewardSession.slider.selectedPoints /
                    this.rewardSession.slider.CONVERSION_FACTOR;
            return Math.round(convertPointToAmmount * 10000) / 10000;
        }
        if (this.rewardSession.reward.conversion.conversion_rate_type ===
            CONVERSION_TYPES.CREDIT_BY_CURRENCY) {
            convertPointToAmmount =
                this.rewardSession.slider.selectedPoints *
                    this.rewardSession.slider.CONVERSION_FACTOR;
            return convertPointToAmmount;
        }
    }
    /**
     * @description set value session store
     * @memberof SliderComponent
     */
    setSessionStore() {
        window.sessionStorage.setItem(this.rewardSessionKey, JSON.stringify(this.rewardSession));
    }
    validSendTypeRewards() {
        if (!this.cartProducts) {
            this.onSelectedPointsChange.emit(this.slider);
        }
        else {
            this.onSelectedPointsChange.emit(this.creditsRewards);
        }
    }
    handleError(error) {
        if (error && error.error) {
            this.outError.emit(error.error);
        }
        else {
            this.outError.emit(new AlliancesError()
                .builder()
                .code('500')
                .messages('Error server')
                .build());
        }
        return throwError(error);
    }
}
SliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SliderComponent, deps: [{ token: i1$2.AlliancesServicesService }, { token: i1.Store }], target: i0.ɵɵFactoryTarget.Component });
SliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: SliderComponent, selector: "am-alliances-slider", inputs: { isForceHiding: ["forceOffComponent", "isForceHiding"], cartProducts: ["products", "cartProducts"], channelProduct: ["product", "channelProduct"] }, outputs: { onSelectedPointsChange: "outSelectedPoints", outError: "outError" }, ngImport: i0, template: "<section class=\"slider-container\" *ngIf=\"showComponent(context$ | async)\">\n  <div\n    class=\"slider-container__content\"\n    *ngIf=\"!!rewardSession && !!availabilityRewards\"\n  >\n    <!-- Slider line -->\n    <div class=\"slider-container__line-box\">\n      <am-line-slider\n        [brandConfig]=\"brandConfig$ | async\"\n        [minLimit]=\"availabilityRewards?.pointsPaymentRange?.min\"\n        [maxLimit]=\"availabilityRewards?.pointsPaymentRange?.max\"\n        [top]=\"availabilityRewards?.cartPoints\"\n        [points]=\"slider?.points\"\n        [selectedPoints]=\"slider?.selectedPoints\"\n        (selectedPointsChange)=\"onEmitterSelectedPoints($event)\"\n      ></am-line-slider>\n    </div>\n\n    <!-- Slider input box -->\n    <div class=\"slider-container__input-box\">\n      <am-input-slider\n        [brandConfig]=\"brandConfig$ | async\"\n        [minLimit]=\"availabilityRewards?.pointsPaymentRange?.min\"\n        [maxLimit]=\"availabilityRewards?.pointsPaymentRange?.max\"\n        [top]=\"availabilityRewards?.cartPoints\"\n        [points]=\"slider?.points\"\n        [selectedPoints]=\"slider?.selectedPoints\"\n        (selectedPointsChange)=\"onEmitterSelectedPoints($event)\"\n      ></am-input-slider>\n    </div>\n  </div>\n\n  <p *ngIf=\"showTaxesLabel\" class=\"slider-container__taxes-label\">\n    <span class=\"slider-container__taxes-tag\"></span> Los impuestos y tasas no\n    pueden ser pagados parcialmente con puntos, solo en su totalidad.\n  </p>\n</section>\n", styles: [".am-payment-reward{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.am-payment-reward{line-height:1.5}}.slider-container__content{align-items:center;background-color:#fff;display:flex;justify-content:flex-start;padding:1rem}.slider-container__line-box{width:100%}@media screen and (min-width: 480px){.slider-container__line-box{width:calc(100% - 190px)}}.slider-container__input-box{align-items:center;display:flex;margin-top:8px;width:190px}@media screen and (min-width: 480px){.slider-container__input-box{margin-bottom:22px;margin-top:0}}.slider-container__taxes-label{align-items:flex-start;color:#454848;display:flex;font-family:ProximaNova,Roboto;font-size:12px;line-height:1.17;margin:20px;position:relative}.slider-container__taxes-tag{background-image:linear-gradient(to right,#9fa2a2 80%,rgba(255,255,255,0) 0);background-position:inherit;background-repeat:repeat-x;background-size:10px 4px;border:0;height:3px;margin-right:10px;margin-top:5px;min-width:20px;overflow:unset;width:20px}.slider-container__taxes-tag:before{background-color:#9fa2a2;content:\"\";height:15px;left:-3px;position:absolute;top:-1px;width:3px;z-index:3}\n"], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: LineSliderComponent, selector: "am-line-slider", inputs: ["brandConfig", "minLimit", "maxLimit", "top", "points", "selectedPoints"], outputs: ["selectedPointsChange"] }, { kind: "component", type: AmInputSliderComponent, selector: "am-input-slider", inputs: ["brandConfig", "minLimit", "maxLimit", "top", "points", "selectedPoints"], outputs: ["selectedPointsChange"] }, { kind: "pipe", type: i2.AsyncPipe, name: "async" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'am-alliances-slider', template: "<section class=\"slider-container\" *ngIf=\"showComponent(context$ | async)\">\n  <div\n    class=\"slider-container__content\"\n    *ngIf=\"!!rewardSession && !!availabilityRewards\"\n  >\n    <!-- Slider line -->\n    <div class=\"slider-container__line-box\">\n      <am-line-slider\n        [brandConfig]=\"brandConfig$ | async\"\n        [minLimit]=\"availabilityRewards?.pointsPaymentRange?.min\"\n        [maxLimit]=\"availabilityRewards?.pointsPaymentRange?.max\"\n        [top]=\"availabilityRewards?.cartPoints\"\n        [points]=\"slider?.points\"\n        [selectedPoints]=\"slider?.selectedPoints\"\n        (selectedPointsChange)=\"onEmitterSelectedPoints($event)\"\n      ></am-line-slider>\n    </div>\n\n    <!-- Slider input box -->\n    <div class=\"slider-container__input-box\">\n      <am-input-slider\n        [brandConfig]=\"brandConfig$ | async\"\n        [minLimit]=\"availabilityRewards?.pointsPaymentRange?.min\"\n        [maxLimit]=\"availabilityRewards?.pointsPaymentRange?.max\"\n        [top]=\"availabilityRewards?.cartPoints\"\n        [points]=\"slider?.points\"\n        [selectedPoints]=\"slider?.selectedPoints\"\n        (selectedPointsChange)=\"onEmitterSelectedPoints($event)\"\n      ></am-input-slider>\n    </div>\n  </div>\n\n  <p *ngIf=\"showTaxesLabel\" class=\"slider-container__taxes-label\">\n    <span class=\"slider-container__taxes-tag\"></span> Los impuestos y tasas no\n    pueden ser pagados parcialmente con puntos, solo en su totalidad.\n  </p>\n</section>\n", styles: [".am-payment-reward{font-size:.875rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.am-payment-reward{line-height:1.5}}.slider-container__content{align-items:center;background-color:#fff;display:flex;justify-content:flex-start;padding:1rem}.slider-container__line-box{width:100%}@media screen and (min-width: 480px){.slider-container__line-box{width:calc(100% - 190px)}}.slider-container__input-box{align-items:center;display:flex;margin-top:8px;width:190px}@media screen and (min-width: 480px){.slider-container__input-box{margin-bottom:22px;margin-top:0}}.slider-container__taxes-label{align-items:flex-start;color:#454848;display:flex;font-family:ProximaNova,Roboto;font-size:12px;line-height:1.17;margin:20px;position:relative}.slider-container__taxes-tag{background-image:linear-gradient(to right,#9fa2a2 80%,rgba(255,255,255,0) 0);background-position:inherit;background-repeat:repeat-x;background-size:10px 4px;border:0;height:3px;margin-right:10px;margin-top:5px;min-width:20px;overflow:unset;width:20px}.slider-container__taxes-tag:before{background-color:#9fa2a2;content:\"\";height:15px;left:-3px;position:absolute;top:-1px;width:3px;z-index:3}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.AlliancesServicesService }, { type: i1.Store }]; }, propDecorators: { isForceHiding: [{
                type: Input,
                args: ['forceOffComponent']
            }], cartProducts: [{
                type: Input,
                args: ['products']
            }], channelProduct: [{
                type: Input,
                args: ['product']
            }], onSelectedPointsChange: [{
                type: Output,
                args: ['outSelectedPoints']
            }], outError: [{
                type: Output
            }] } });

class AmOnlyNumbersDirective {
    constructor(el) {
        this.el = el;
        this.navigationKeys = [
            'Backspace',
            'Delete',
            'Tab',
            'Escape',
            'Enter',
            'Home',
            'End',
            'ArrowLeft',
            'ArrowRight',
            'Clear',
            'Copy',
            'Paste'
        ];
        this.inputElement = el.nativeElement;
    }
    onKeyDown(e) {
        if (this.navigationKeys.indexOf(e.key) > -1 || // Allow: navigation keys: backspace, delete, arrows etc.
            (e.key === 'a' && e.ctrlKey === true) || // Allow: Ctrl+A
            (e.key === 'c' && e.ctrlKey === true) || // Allow: Ctrl+C
            (e.key === 'v' && e.ctrlKey === true) || // Allow: Ctrl+V
            (e.key === 'x' && e.ctrlKey === true) || // Allow: Ctrl+X
            (e.key === 'a' && e.metaKey === true) || // Allow: Cmd+A (Mac)
            (e.key === 'c' && e.metaKey === true) || // Allow: Cmd+C (Mac)
            (e.key === 'v' && e.metaKey === true) || // Allow: Cmd+V (Mac)
            (e.key === 'x' && e.metaKey === true) // Allow: Cmd+X (Mac)
        ) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if (
        // tslint:disable-next-line: deprecation
        (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
            // tslint:disable-next-line: deprecation
            (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    }
    onPaste(event) {
        event.preventDefault();
        const pastedInput = event.clipboardData
            .getData('text/plain')
            .replace(/\D/g, ''); // get a digit-only string
        document.execCommand('insertText', false, pastedInput);
    }
    onDrop(event) {
        event.preventDefault();
        const textData = event.dataTransfer.getData('text').replace(/\D/g, '');
        this.inputElement.focus();
        document.execCommand('insertText', false, textData);
    }
}
AmOnlyNumbersDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmOnlyNumbersDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
AmOnlyNumbersDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: AmOnlyNumbersDirective, selector: "[amOnlyNumbers]", host: { listeners: { "keydown": "onKeyDown($event)", "paste": "onPaste($event)", "drop": "onDrop($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmOnlyNumbersDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[amOnlyNumbers]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onPaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }], onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }] } });

const components = [
    LineSliderComponent,
    SliderComponent,
    AmInputSliderComponent,
    SliderInfoComponent,
    SliderGapComponent
];
class AmSliderPointsModule {
    constructor(iconRegistry) {
        this.iconRegistry = iconRegistry;
        iconRegistry.addSvgIconDefinition(aciAdd);
        iconRegistry.addSvgIconDefinition(aciSub);
    }
}
AmSliderPointsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmSliderPointsModule, deps: [{ token: i2$2.MbIconRegistry }], target: i0.ɵɵFactoryTarget.NgModule });
AmSliderPointsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: AmSliderPointsModule, declarations: [LineSliderComponent,
        SliderComponent,
        AmInputSliderComponent,
        SliderInfoComponent,
        SliderGapComponent, AmOnlyNumbersDirective, ReplacePointsPipe], imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        AlliancesServicesModule,
        MbFormFieldModule,
        MbIconModule,
        MbTooltipModule,
        NgxSliderModule], exports: [SliderComponent] });
AmSliderPointsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmSliderPointsModule, providers: [DecimalPipe], imports: [CommonModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        AlliancesServicesModule,
        MbFormFieldModule,
        MbIconModule,
        MbTooltipModule,
        NgxSliderModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmSliderPointsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormsModule,
                        HttpClientModule,
                        AlliancesServicesModule,
                        MbFormFieldModule,
                        MbIconModule,
                        MbTooltipModule,
                        NgxSliderModule,
                    ],
                    declarations: [...components, AmOnlyNumbersDirective, ReplacePointsPipe],
                    exports: [SliderComponent],
                    providers: [DecimalPipe],
                }]
        }], ctorParameters: function () { return [{ type: i2$2.MbIconRegistry }]; } });

/*
 * Public API Surface of  @am/slider-points
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AmSliderPointsModule, SliderComponent };
